/* eslint-disable no-debugger */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import * as React from 'react';
import { Button } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
//import Modal from 'reactstrap/lib/Modal';
//import ModalBody from 'reactstrap/lib/ModalBody';

export interface ILobasGlbViewerProps {
    itemId: string;
    onClick?(): void;
    label: string;
    className: string;
}

export interface ILobasGlbViewerState {
    show: boolean;
    modal: boolean;
}

/**
 *
 * LobasGlbViewer component
 * @extends {React.PureComponent<ILobasGlbViewerProps>}
 */
export default class LobasGlbViewer extends React.PureComponent<ILobasGlbViewerProps, ILobasGlbViewerState> {
    public constructor(props: ILobasGlbViewerProps) {
        super(props);
        this.state = { show: false, modal: false };
    }

    public componentDidMount() {
        void fetch(`https://lob.as/3d/${this.props.itemId}.zip`).then(res => {
            console.log(res);
            if (res.status === 200) {
                this.setState({ show: true });
            }
        });
    }

    public render(): JSX.Element {
        if (this.state.show) {
            return (
                <div className='lobas-glb-viewer'>
                    <Button
                        className={classnames('lobas-glb-viewer__btn', this.props.className)}
                        title={this.props.label}
                        onClick={this.props.onClick}
                    >
                        {this.props.label}
                    </Button>
                </div>
            );
        } else {
            return <></>;
        }
    }
}

export function AddScript(urlOfTheLibrary: string) {
    if (DoesScriptExist(urlOfTheLibrary)) {
        RemoveScript(urlOfTheLibrary);
    }

    if (typeof window !== 'undefined') {
        const script = document.createElement('script');
        script.src = urlOfTheLibrary;
        script.async = true;
        document.body.appendChild(script);
    }
}

export function RemoveScript(urlOfTheLibrary: string) {
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src.includes(urlOfTheLibrary)) {
            document.body.removeChild(scripts[i]);
            return;
        }
    }
}

export function DoesScriptExist(urlOfTheLibrary: string) {
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].src.includes(urlOfTheLibrary)) {
            return true;
        }
    }
    return false;
}
